
//Toggle value (returns a new array)
export function toggleValueInArray(array, value) {
  if (!Array.isArray(array)) {
    array = []
  }
  const clone = [...array]
  toggleValueInArrayInPlace(clone, value)
  return clone
}

//Toggle value (modifies existing array)
export function toggleValueInArrayInPlace(array, value) {
  if (!Array.isArray(array)) {
    return
  }
  const i = array.indexOf(value)
  if (i === -1) {
    array.push(value)
  }
  else {
    array.splice(i, 1)
  }
}

//Check if two arrays contain the same values
export function arraysMatch(array1, array2) {
  if (array1.length !== array2.length) {
    return false
  }
  return (
    array1.every(value => array2.includes(value)) &&
    array2.every(value => array1.includes(value))
  )
}

//Create an array with a sequence of numbers
export function arraySequence(start, end, step = 1) {
  return Array
    .from(Array(Math.floor((end - start + 1) / step)).keys())
    .map(i => i + start)
}

//Set value at index and return a new array
export function setValueAtIndex(array, index, value) {
  return [
    ...array.slice(0, index),
    value,
    ...array.slice(index + 1),
  ]
}

//Insert value in array after another value
export function insertAfter(array, afterValue, value) {
  const i = array.indexOf(afterValue)
  if (i === -1) {
    return [...array, value]
  }
  return [
    ...array.slice(0, i),
    value,
    ...array.slice(i),
  ]
}
